let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hszIA")).then(() => parcelRequire('20uDq'));